import React from 'react'

const Title = ({videos}) => {
  return (
    <div className="row w-100 title-bar">
        <div className="col-sm-12 d-flex justify-content-between align-items-center bg-warning">
            <h1 id="app-title" className="font-weight-bold text-center white-text pl-3 pt-2" >Videoteca</h1>
            {
            videos.length > 0 ? <h2 className='display-5 font-weight-bold text-center white-text'>Total: {videos.length}</h2> : null
            }
        </div>
    </div>
  )
}

export default Title
